// Status mapping constants for stepper component

export const STATUS_REPORTED = -1;
export const STATUS_WORK_COMPLETED = 34;
export const STATUS_REJECTED = 3;
export const STATUS_WORK_HOLD = 14;
export const STATUS_NAME_REPORTED = 'Reported';
export const STATUS_NAME_INSPECTION_SKIPPED = 'Inspection skipped';
export const STATUS_NAME_ESTIMATION_SKIPPED = 'Estimation skipped';
export const STATUS_NAME_ESTIMATION_APPROVED = 'Estimation approved';
export const STATUS_NAME_WORK_ON_HOLD = 'Work on hold';
export const STATUS_NAME_WORK_REPORT_COMPLETED = 'Work report completed';
export const STATUS_NAME_OPEN = 'Open';
export const getCurrentStatus = (status) => {
  switch (status) {
    case 1:
    case 0:
      return 0; // not attended
    case 12:
      return 6; // completed
    case 14:
      return 3; // hold
    case 16:
      return 6; // completed
    case 10:
      return 6;
    case 20:
      return 1;
    case 21:
      return 6;
    case 22:
      return 4; // skipped
    case 25:
      return 4;
    case 23:
      return 1;
    case 24:
      return 1;
    case 27:
      return 6;
    case 3:
      return 5; // rejected by client
    case 30:
      return 1;
    case 32:
      return 6;
    case 34:
      return 6;
    default:
      return 0;
  }
};

export const getStatusName = (status) => {
  switch (status) {
    case 0:
      return 'UNASSIGNED';
    case 3:
      return 'REJECTED'; // STATUS_REJECTED
    case 10:
      return 'OPEN'; // STATUS_OPEN
    case 12:
      return 'ASSIGNED'; // STATUS_ASSIGNED
    case 14:
      return 'WORK ON HOLD'; // STATUS_WORK_ON_HOLD
    case 16:  
      return 'ACCEPTED'; // STATUS_ACCEPTED
    case 20:
      return 'INSPECTION IN PROGRESS'; // STATUS_EVALUATION_IN_PROGRESS
    case 21:
      return 'INSPECTION COMPLETED'; // STATUS_EVALUATION_COMPLETED
    case 22:
      return 'INSPECTION SKIPPED'; // STATUS_EVALUATION_SKIPPED
    case 23:
      return 'ESTIMATION IN PROGRESS'; // STATUS_ESTIMATION_IN_PROGRESS
    case 24:
      return 'ESTIMATION COMPLETED'; // STATUS_ESTIMATION_COMPLETED
    case 25:
      return 'ESTIMATION SKIPPED'; // STATUS_ESTIMATION_SKIPPED
    case 26:
      return 'ESTIMATION SENT'; // STATUS_ESTIMATION_SEND
    case 27:    
      return 'ESTIMATION APPROVED'; // STATUS_ESTIMATION_APPROVED
    case 28:
      return 'ESTIMATION REJECTED BY CLIENT'; // STATUS_ESTIMATION_REJECTED_BY_CLIENT
    case 30:
      return 'WORK STARTED'; // STATUS_WORK_STARTED
    case 32:
      return 'WORK REPORT COMPLETED'; // STATUS_WORK_REPORT_COMPLETED
    case 34:
      return 'WORK COMPLETED'; // STATUS_WORK_COMPLETED
    default:
      return 'UNKNOWN';
  }
};